import React, { useEffect, useState } from 'react'
import throttle from 'lodash.throttle'
import ChevronDownIcon from 'shared/icons/chevron-down-icon'

export const ScrollToTopButton: React.FC = () => {
  const [showScrollToTop, setShowScrollToTop] = useState(false)

  useEffect(() => {
    const handleScroll = throttle(() => {
      setShowScrollToTop(window.scrollY > 300)
    }, 200)

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  if (!showScrollToTop) {
    return null
  }

  return (
    <button
      onClick={scrollToTop}
      className="fixed right-4 bottom-4 flex size-10 items-center justify-center rounded-full bg-text-primary text-background-secondary shadow-md"
    >
      <ChevronDownIcon className="size-3.5 rotate-180" />
    </button>
  )
}
